/**
 * Route for `error-states-retry-button`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ErrorStatesRetryButtonPage } from "../features/error-states-retry-button/ErrorStatesRetryButtonPage";

export const errorStatesRetryButtonRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/error-states-retry-button",
	component: ErrorStatesRetryButtonPage,
});

export default errorStatesRetryButtonRoute;
